import Box from '@mui/material/Box';
import { observer } from 'mobx-react-lite';
import { Page, PromiseContainer } from '../../components';
import { useStore } from '../../store';
import usePromise from '../../store/utils/usePromise';
import StatForm from './components/StatForm';
import StatGraph from './components/StatGraph';

export default observer(function StatsPage() {
  const { pulseKeyStore } = useStore();
  const [statRequestPromise] = usePromise(() =>
    pulseKeyStore.createStatRequest(),
  );

  return (
    <Page navigation={{ title: 'Product redemptions', icon: 'chart-pie' }}>
      <PromiseContainer promise={statRequestPromise}>
        {(statRequest) => (
          <>
            <StatForm statRequest={statRequest} />
            <Box mt={4}>
              <StatGraph statRequest={statRequest} />
            </Box>
          </>
        )}
      </PromiseContainer>
    </Page>
  );
});
